import { CustomSelect } from '@/components';

export function PipelineStageSelect({
  stages = [],
  value,
  disabled,
  onChange,
  helperText = 'Applied when the customer reaches this step. None leaves the stage unchanged.',
  compact = false,
}) {
  const selected = stages.find((stage) => String(stage.id) === String(value));
  const unresolved = value != null && value !== '' && !selected;
  const options = [
    { value: '', label: 'None (Do not change stage)', color: '' },
    ...(unresolved
      ? [
          {
            value: String(value),
            label: `Unresolved stage #${value}`,
            color: '#B45309',
          },
        ]
      : []),
    ...[...stages]
      .sort(
        (a, b) =>
          (a.display_order ?? 0) - (b.display_order ?? 0) ||
          String(a.name).localeCompare(String(b.name)),
      )
      .map((stage) => ({
        value: String(stage.id),
        label: stage.name,
        color: stage.color || '#94A3B8',
      })),
  ];

  return (
    <div
      className={`text-left min-w-0 ${compact ? 'space-y-1' : 'space-y-1.5'}`}
    >
      <label
        className={`block font-medium text-text-secondary ${compact ? 'text-sm' : 'text-xs'}`}
      >
        Pipeline stage
      </label>
      <CustomSelect
        value={value != null && value !== '' ? String(value) : ''}
        disabled={disabled}
        onChange={(val) => {
          if (val === '') {
            onChange(null, null);
            return;
          }
          const stage = stages.find((item) => String(item.id) === String(val));
          if (!stage) return;
          onChange(Number(stage.id), stage);
        }}
        options={options}
        hideCheckIcon
        textSizeClass="text-sm"
        buttonClassName={`w-full flex items-center justify-between rounded-lg bg-white border border-border-default text-text-primary text-sm px-3 ${
          compact ? 'h-9' : 'h-10'
        } ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
        renderOption={(option) => (
          <span className="flex items-center gap-2 min-w-0">
            {option.color ? (
              <span
                className="w-2.5 h-2.5 rounded-full shrink-0"
                style={{ backgroundColor: option.color }}
              />
            ) : null}
            <span className="truncate">{option.label}</span>
          </span>
        )}
      />
      {selected && (
        <span className="inline-flex items-center gap-1.5 text-[11px] text-text-secondary">
          <span
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: selected.color || '#94A3B8' }}
          />
          {selected.name}
          {selected.is_lost ? ' · Lost' : ''}
          {selected.is_won ? ' · Won' : ''}
        </span>
      )}
      {unresolved && (
        <p className="text-xs leading-snug text-amber-700">
          Stage #{value} is not in this company. Saved id stays until you pick
          another stage.
        </p>
      )}
      {helperText && (
        <p className="text-xs leading-snug text-text-muted">{helperText}</p>
      )}
    </div>
  );
}
